import { render, staticRenderFns } from "./DocumentLayer.vue?vue&type=template&id=b9bd7f08&scoped=true&"
import script from "./DocumentLayer.vue?vue&type=script&lang=js&"
export * from "./DocumentLayer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLayer.vue?vue&type=style&index=0&id=b9bd7f08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bd7f08",
  null
  
)

export default component.exports